<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Coming Soon Area -->
<div class="coming-soon-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="coming-soon-content">
          

                <h2>{{updatePhotoText}}</h2>

                <div style="margin-top:20px">
                    
                    <form [formGroup]="form">
                        <div class="form-group">
                        <img *ngIf="imageSrc" [src]="imageSrc" class="avatar">
                    
                        <div class="flex clearfix">
                            <label class="button btn-file ">{{chooseFile}}
                            <input class="hidden" type="file" accept="image/*"
                                (change)="onFileChange(fileInput.files)" #fileInput>
                            </label>
<!-- 
                            <label class="button btn-file pull-left" [disabled]="form.invalid || loading">Submit
                                </label> -->
                            
                            <button type="submit" class="button app-btn"
                            [disabled]="form.invalid" (click)="onSubmit()">
                            {{submit}}
            
                            </button>
                        </div>
                        </div>
                    </form>
                   
                </div>

                <!-- <a class="app-btn" href="javascript:;" (click)="onUpload()">Upload</a> -->
            </div>
        </div>
    </div>
</div>
<!-- End Coming Soon Area -->